<template>
  <div class="detail-container">
    <el-button @click="$router.back()">返回列表</el-button>
    <el-card v-loading="loading" :loading-text="'加载中...'">
      <el-descriptions column="1" border>
        <el-descriptions-item label="客户 ID">{{ customer.customer_id }}</el-descriptions-item>
        <el-descriptions-item label="名称">{{ customer.name }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ customer.contact || '无' }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ customer.address || '无' }}</el-descriptions-item>
      </el-descriptions>
      <div style="text-align: right; margin-top: 20px;">
        <el-button type="primary" @click="openEditDialog">编辑</el-button>
        <el-button type="danger" @click="handleDelete">删除</el-button>
      </div>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑客户" v-model="editDialogVisible" width="400px">
      <el-form :model="editForm" ref="editForm" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input v-model="editForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="editForm.address"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      customer: {}, // 客户详情数据
      loading: false,
      editDialogVisible: false,
      editForm: {
        name: '',
        contact: '',
        address: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.fetchCustomerDetail();
  },
  methods: {
    // 获取客户详情
    async fetchCustomerDetail() {
      this.loading = true;
      try {
        const res = await request.get(`/api/customers/${this.id}`);
        // 直接使用 res 而非 res.data（因为 request 已在响应拦截器中返回 response.data）
        this.customer = res;
        // 初始化编辑表单（过滤不需要的字段）
        this.editForm = {
          name: this.customer.name,
          contact: this.customer.contact,
          address: this.customer.address
        };
      } catch (error) {
        console.error('获取客户详情失败:', error);
        this.$message.error(error.message || '获取客户详情失败，请重试');
      } finally {
        this.loading = false;
      }
    },

    // 打开编辑弹窗
    openEditDialog() {
      this.editDialogVisible = true;
    },

    // 提交编辑
    async submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          try {
            await request.put(`/api/customers/${this.id}`, this.editForm);
            this.$message.success('编辑成功');
            this.editDialogVisible = false;
            this.fetchCustomerDetail(); // 重新加载详情
          } catch (error) {
            console.error('编辑客户失败:', error);
            this.$message.error(error.message || '编辑客户失败，请重试');
          }
        }
      });
    },

    // 删除客户
    async handleDelete() {
      try {
        // 确认弹窗（适配 Element Plus 的 Promise 用法）
        await this.$confirm('确定删除该客户吗？删除后无法恢复！', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        // 执行删除
        await request.delete(`/api/customers/${this.id}`);
        this.$message.success('删除成功');
        this.$router.push('/customers'); // 跳转回列表页
      } catch (error) {
        // 取消确认时也会触发 catch，需判断是否为取消操作
        if (error === 'cancel' || error.name === 'CanceledError') {
          this.$message.info('已取消删除');
        } else {
          console.error('删除客户失败:', error);
          this.$message.error(error.message || '删除客户失败，请重试');
        }
      }
    },
  },
};
</script>

<style scoped>
.detail-container {
  padding: 20px;
}
</style>